import { React, Button as MUIButton, ButtonProps as MUIButtonProps } from '../../utils/globalImports';

interface CustomButtonProps extends MUIButtonProps {
  fullWidth?: boolean;  // Will always be full width
  disabled?: boolean;
  capsule?: boolean;    // If true, the button will have a capsule shape
  sx?: any;             // Custom styles for the button (including padding, background, etc.)
  backgroundColor?: string;
  hoverColor?: string;
  hoverFontColor?: string;
  type?: 'button' | 'submit' | 'reset'; // Optional, but defaults to 'submit'
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void; // Add the onClick handler
}

const CustomButton: React.FC<CustomButtonProps> = ({
  fullWidth = true,
  disabled = false,
  capsule = false,
  sx,
  backgroundColor = 'rgba(150, 193, 33, 0.75)',
  hoverColor = '#1e66ab',
  hoverFontColor = '#fff',
  type = 'submit', //  Default to 'submit'
  children,
  onClick,
  ...props
}) => {
  return (
    <MUIButton
      type={type}
      variant="contained"
      size="large"
      fullWidth={fullWidth}
      disabled={disabled}  // Add this line to disable the button when needed
      sx={{
        ...sx,
        backgroundColor: backgroundColor,
        ...(capsule && { borderRadius: '20px', paddingLeft: '30px', paddingRight: '30px' }), // Capsule shape
        // Hover effect: change background color on hover
        '&:hover': {
          backgroundColor: hoverColor,
          color: hoverFontColor,
        },
      }}
      onClick={onClick} // Pass the onClick prop to MUIButton
      {...props}
    >
      {children}
    </MUIButton>
  );
};

export default CustomButton;
